import {
  ToggleOption,
  ToggleSetting,
} from './utils';

const texts = {
  description: {
    [ToggleSetting.AUTO_ASSIGNMENT]: 'Automatically assign meal plans for new clients',
    [ToggleSetting.AUTO_REFRESH]: 'Automatically refresh live meal plans for users needing a refresh',
  },
  button: {
    [ToggleSetting.AUTO_ASSIGNMENT]: {
      [ToggleOption.ENABLE]: 'Enable auto assignment',
      [ToggleOption.DISABLE]: 'Disable auto assignment',
    },
    [ToggleSetting.AUTO_REFRESH]: {
      [ToggleOption.ENABLE]: 'Enable auto refresh',
      [ToggleOption.DISABLE]: 'Disable auto refresh',
    },
  },
  saved: 'Meal plan automation settings saved',
  error: 'Could not save meal plan automation settings: {error}',
};

export default texts;
